import { FC } from 'react'
import { cn } from '@wellesley/ui'
import { PrivacyMarkdown, TermsMarkdown } from 'components/markdown'
import ModalWithButton from 'components/modals/ModalWithButton'

type TermsProps = {
  isDarkBg?: boolean
}

export const Terms: FC<TermsProps> = ({ isDarkBg }) => {
  const textColorClass = isDarkBg ? 'text-white/90' : 'text-gray-900/90'

  return (
    <div
      data-testid="branding-terms"
      className={cn(
        'flex w-[180px] justify-between text-sm font-normal',
        textColorClass,
      )}
    >
      <ModalWithButton modalTitle="Privacy Policy" modalSlug="privacy">
        <PrivacyMarkdown />
      </ModalWithButton>
      <ModalWithButton modalTitle="Terms of Use" modalSlug="terms">
        <TermsMarkdown />
      </ModalWithButton>
    </div>
  )
}
